<div class="spinner">
  <i
    class="pi pi-spin pi-spinner"
    [style]="{ fontSize: size() || '5rem' }"
  ></i>
</div>
